module.exports = __webpack_public_path__ + "assets/img/Type BS (16).d9d92af5.jpg";